const apiBase = process.env.NODE_ENV === 'production' ? '' : 'http://localhost:3001';

async function handleResponse(res) {
    if (!res.ok) {
        const text = await res.text();
        throw new Error(text || `Request failed with status ${res.status}`);
    }
    const contentType = res.headers.get('content-type') || '';
    if (contentType.includes('application/json')) {
        return res.json();
    }
    return res.text();
}

export async function fetchChallengesConfig() {
    const url = `${apiBase}/api/riot/challenges/config`;
    try {
        const res = await fetch(url);
        return handleResponse(res);
    } catch (err) {
        // Provide clearer error for network failures
        throw new Error(`Failed to fetch challenges config from ${url}: ${err.message}`);
    }
}

// Deprecated: by-name lookups are intentionally removed; prefer PUUID or RiotID endpoints above.
// (If you need a by-name helper in the future, add it here and ensure backend supports it.)
export async function fetchPlayerChallengesByPuuid(puuid) {
    const url = `${apiBase}/api/riot/challenges/player/by-puuid/${encodeURIComponent(puuid)}`;
    try {
        const res = await fetch(url);
        return handleResponse(res);
    } catch (err) {
        throw new Error(`Failed to fetch player challenges for puuid '${puuid}' from ${url}: ${err.message}`);
    }
}

export async function fetchPlayerChallengesByRiotId(riotId) {
    // riotId should be provided as name#tag (URL-encoded by caller). The backend route expects the '#' encoded as %23.
    const url = `${apiBase}/api/riot/challenges/player/by-riot-id/${encodeURIComponent(riotId)}`;
    try {
        const res = await fetch(url);
        return handleResponse(res);
    } catch (err) {
        throw new Error(`Failed to fetch player challenges for RiotID '${riotId}' from ${url}: ${err.message}`);
    }
}

// New: fetch account information (human-friendly gameName) by PUUID
export async function fetchAccountByPuuid(puuid) {
    const url = `${apiBase}/api/riot/account/by-puuid/${encodeURIComponent(puuid)}`;
    try {
        const res = await fetch(url);
        return handleResponse(res);
    } catch (err) {
        throw new Error(`Failed to fetch account by puuid '${puuid}' from ${url}: ${err.message}`);
    }
}
